import React from 'react';

import { Col } from 'antd';
import { ProfileWrapper, WrapperRow } from './styles';
import EditProfile from '../../Components/EditProfile/EditProfile';
import SnagSection from '../../Components/SnagSection/SnagSection';
import ToJS from '../../../Contributions/Pages/ContributionsDashboard/HOC/toJS';
import PropTypes from 'prop-types';
import CarouselComponent from '../../../../CommonComponents/Carousel/CarouselComponent';

const SummaryNotes = ({ carouselData, goToPage }) => {
  const dataCheck = carouselData.length;
  return (
    <WrapperRow center={carouselData.length ? false : true}>
      <Col lg={{ span: '8' }} sm={{ span: '24' }} xs={{ span: '24' }}>
        <ProfileWrapper>
          <EditProfile goToPage={(path) => goToPage(path)} />
          {carouselData.length ? <SnagSection /> : null}
        </ProfileWrapper>
      </Col>
      <Col
        sm={{ span: dataCheck ? '24' : '0' }}
        lg={{ span: dataCheck ? '16' : '0' }}
        xs={{ span: dataCheck ? '24' : '0' }}
      >
        <CarouselComponent isFull/>
      </Col>
    </WrapperRow>
  );
};
SummaryNotes.propTypes = {
  carouselData: PropTypes.array,
  goToPage: PropTypes.func.isRequired,
};
export default ToJS(SummaryNotes);
